<template>
  <v-container class="pa-6" style="max-width: 1680px">
    <notification-component
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
      :display="'node'"
      class="mb-6"
      @editAlert="editAlert"
    />
    <v-row align="center">
      <v-col cols="auto" class="pr-0">
        <v-btn
          icon
          outlined
          color="grey"
          style="background-color: 'rgba(0, 0, 0, 0.05)"
          @click="toChain()"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-col>
      <v-col
        cols="auto"
        class="pr-0"
        style="cursor: pointer"
        @click="toChain()"
      >
        <v-img
          min-height="24"
          max-width="24"
          contain
          :src="chainIcon"
          style="margin-bottom: 2px; margin-top: -2px"
        ></v-img>
      </v-col>
      <v-col
        cols="auto"
        class="pr-0"
        style="cursor: pointer"
        @click="toChain()"
      >
        <div class="text-h5">
          <span
            style="
              font-family: Inter;
              text-transform: uppercase;
              font-weight: 600;
            "
            >{{ chainTitle }}</span
          >
        </div>
      </v-col>
      <v-col cols="auto" class="px-0">
        <div class="text-h5">
          <span
            style="
              font-family: Inter;
              text-transform: uppercase;
              padding-left: 8px;
              padding-right: 8px;
            "
          >
            /
          </span>
        </div>
      </v-col>
      <v-col cols="auto" class="pl-0">
        <div class="text-h5">
          <span style="font-family: Inter; text-transform: uppercase">{{
            nodeTitle
          }}</span>
        </div>
      </v-col>
      <v-col cols="auto" class="pl-0">
        <v-chip
          outlined
          :color="nodeTypeColor"
          label
          style="
            background-color: white !important;
            text-transform: capitalize;
            height: 36px;
          "
        >
          {{ nodeType }}
        </v-chip>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-chip
          v-if="thisNodeStatus == 'active'"
          light
          label
          outlined
          class="rounded-pill"
          style="
            height: 36px;
            background-color: hsl(120, 67%, 94%) !important;
            color: hsl(120, 67%, 39%) !important;
            border-color: hsl(120, 67%, 39%) !important;
          "
        >
          <v-icon color="hsl(120, 67%, 39%)" class="mr-1">mdi-circle</v-icon>
          <span style="font-family: Inter; color: hsl(120, 67%, 39%)"
            >Active</span
          >
        </v-chip>
        <v-chip
          v-else-if="thisNodeStatus == 'errors'"
          light
          label
          outlined
          class="rounded-pill ml-3"
          style="
            height: 36px;
            background-color: hsl(40, 87%, 94%) !important;
            color: hsl(40, 87%, 49%) !important;
            border-color: hsl(40, 87%, 49%) !important;
          "
        >
          <v-icon color="hsl(40, 87%, 49%)" class="mr-1">mdi-circle</v-icon>
          <span style="font-family: Inter; color: hsl(40, 87%, 49%)"
            >Errors</span
          >
        </v-chip>
        <v-chip
          v-if="thisNodeStatus == 'disconnected'"
          light
          label
          outlined
          class="rounded-pill ml-3"
          style="
            height: 36px;
            background-color: hsl(0, 87%, 94%) !important;
            color: hsl(0, 87%, 59%) !important;
            border-color: hsl(0, 87%, 59%) !important;
          "
        >
          <v-icon color="hsl(0, 87%, 59%)" class="mr-1">mdi-circle</v-icon>
          <span style="font-family: Inter; color: hsl(0, 87%, 59%)"
            >Disconnected</span
          >
        </v-chip>
        <v-chip
          v-else-if="thisNodeStatus == 'not connected'"
          light
          label
          outlined
          class="rounded-pill ml-3"
          style="
            height: 36px;
            background-color: hsl(0, 0%, 94%) !important;
            color: hsl(0, 0%, 59%) !important;
            border-color: hsl(0, 0%, 59%) !important;
          "
        >
          <v-icon color="hsl(0, 0%, 59%)" class="mr-1">mdi-circle</v-icon>
          <span style="font-family: Inter; color: hsl(0, 0%, 59%)"
            >Not Connected</span
          >
        </v-chip>
      </v-col>
      <v-col v-if="authStatus" cols="auto" class="pl-0">
        <v-btn
          icon
          outlined
          color="grey"
          style="background-color: 'rgba(0, 0, 0, 0.05)"
          @click="openNodeEditOverlay"
        >
          <v-icon small>mdi-cog</v-icon>
        </v-btn>
      </v-col>
      <v-col v-if="authStatus" cols="auto" class="pl-0">
        <v-btn
          icon
          outlined
          color="grey"
          style="background-color: 'rgba(0, 0, 0, 0.05)"
          @click="openMetricsAndAlertsOverlay"
        >
          <v-icon small>mdi-bell-cog</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" lg="4">
        <address-card :node="node" />
        <endpoints-card
          v-if="endpointAlerts.length > 0"
          :node="node"
          class="mt-6"
        />
        <registered-finalizer-keys-card
          v-if="isRegisteredFinalizerKeysEnabled"
          :node="node"
          class="mt-6"
        />
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <activity-card
          v-if="activityAlerts.length > 0"
          :node="node"
          :activity-alerts="activityAlerts"
          :is-connected="isConnected"
        />
        <producer-card
          v-if="producerAlerts.length > 0"
          :node="node"
          :chain="chain"
          :producer-alerts="producerAlerts"
          class="mt-6"
        />
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <information-card
          v-if="informationAlerts.length > 0"
          :node="node"
          :information-alerts="informationAlerts"
        />
        <producer-schedule-card
          v-if="isProducerScheduleEnabled"
          :node="node"
          class="mt-6"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AddressCard from '../components/Node/AddressCard.vue';
import ActivityCard from '../components/Node/ActivityCard.vue';
import EndpointsCard from '../components/Node/EndpointsCard.vue';
import InformationCard from '../components/Node/InformationCard.vue';
import NotificationComponent from '../components/Notifications/NotificationComponent.vue';
import ProducerCard from '../components/Node/ProducerCard.vue';
import ProducerScheduleCard from '../components/Node/ProducerScheduleCard.vue';
import RegisteredFinalizerKeysCard from '../components/Node/RegisteredFinalizerKeysCard.vue';
import { nodeTypeDictReversed } from '../services/nodeTypeService';
import {
  isInformationMetric,
  isEndpointMetric,
  isProducerMetric,
} from '../services/metricsCategorisation';

export default {
  components: {
    AddressCard,
    ActivityCard,
    InformationCard,
    EndpointsCard,
    NotificationComponent,
    ProducerCard,
    ProducerScheduleCard,
    RegisteredFinalizerKeysCard,
  },
  data: () => ({}),
  computed: {
    isConnected() {
      return this.getRawConnectionStatus(this.node);
    },
    authStatus() {
      return this.$store.state.auth.status;
    },
    chainId() {
      return this.$route.params.chain;
    },
    chain() {
      return this.$store.state.chain.chains.filter(
        (chain) => chain.id === this.$route.params.chain
      )[0];
    },
    chainTitle() {
      return this.chain ? this.chain.name : '';
    },
    chainIcon() {
      return this.chain ? this.chain.icon : '';
    },
    nodeId() {
      return this.$route.params.node;
    },
    node() {
      return this.chain
        ? this.chain.nodes.filter((node) => node.id === this.nodeId)[0]
        : null;
    },
    nodeKey() {
      return this.nodeId + this.nodeChainId;
    },
    nodeChainId() {
      return this.node ? this.node.chain_id : null;
    },
    nodeTitle() {
      return this.node ? this.node.name : '';
    },
    nodeType() {
      let nodeType = this.node ? this.node.type : null;
      if (nodeType in nodeTypeDictReversed) {
        return nodeTypeDictReversed[nodeType];
      }
      return 'Unknown';
    },
    nodeTypeColor() {
      if (this.nodeType === 'Block Producer') return '#0d53ee';
      else if (this.nodeType === 'Full Node') return '#45e09e';
      else return '#479acc';
    },
    thisNodeStatus() {
      return this.nodeStatus(this.node);
    },
    lastMessageId() {
      return this.$store.state.messages.lastMessageId;
    },
    notifications() {
      return this.$store.state.notifications.notifications
        .filter((notification) => {
          return (
            notification.scope === 'node' &&
            notification.source === this.getNodeId() &&
            !notification.archived &&
            notification.notifications_count > 0
          );
        })
        .reverse();
    },
    metrics() {
      let metrics = this.$store.state.metrics.metrics2;
      let enabledMetrics = this.node
        ? this.node.alerts.map((alert) => alert.metric)
        : [];
      enabledMetrics = new Set(enabledMetrics);
      return metrics.filter((metric) =>
        enabledMetrics.has(`${metric.Module}/${metric.Name}`)
      );
    },
    activityAlerts() {
      const metricsDict = this.$store.state.metrics.metricsDict;
      let alerts = this.node?.alerts ?? [];

      function sortAlerts(a, b) {
        if (a.metric.Sort_Order !== b.metric.Sort_Order) {
          return a.metric.Sort_Order - b.metric.Sort_Order;
        }
        if (a.url < b.url) return 1;
        if (a.url > b.url) return -1;
        return 0;
      }

      alerts = alerts
        .map((alert) => {
          const metric = metricsDict[alert.metric];
          return {
            ...alert,
            metric: metric,
            key: `${metric.Module}${metric.Name}${alert.url ?? ''}`,
          };
        })
        .filter(
          (alert) =>
            !isInformationMetric(alert.metric.Module, alert.metric.Name) &&
            !(
              isEndpointMetric(alert.metric.Module, alert.metric.Name) &&
              !['/v1/chain/get_info', '/v2/health', '/health'].includes(
                alert.url
              )
            ) &&
            !(
              alert.metric.Name === 'Latency' &&
              !['/v1/chain/get_info', '/v2/health', '/health'].includes(
                alert.url
              )
            ) &&
            (!isProducerMetric(alert.metric.Module, alert.metric.Name) ||
              alert.metric.Name === 'Head_Block_Producer')
        )
        .sort(sortAlerts);
      return alerts;
    },
    producerAlerts() {
      const metricsDict = this.$store.state.metrics.metricsDict;
      const alerts = this.node?.alerts ?? [];

      const sortedAlerts = alerts
        .map((alert) => {
          const metric = metricsDict[alert.metric];
          return {
            ...alert,
            metric,
            key: `${metric.Module}${metric.Name}${alert.url ?? ''}`,
          };
        })
        .filter(
          (alert) =>
            isProducerMetric(alert.metric.Module, alert.metric.Name) &&
            alert.metric.Name !== 'ProducerSchedule' &&
            alert.metric.Name !== 'RegisteredFinalizerSigningKeys'
        )
        .sort((a, b) => {
          if (a.metric.Sort_Order !== b.metric.Sort_Order) {
            return a.metric.Sort_Order - b.metric.Sort_Order;
          }
          if (a.url < b.url) return 1;
          if (a.url > b.url) return -1;
          return 0;
        });

      return sortedAlerts;
    },
    informationAlerts() {
      const metricsDict = this.$store.state.metrics.metricsDict;
      let alerts = this.node?.alerts ?? [];

      function sortAlerts(a, b) {
        if (a.metric.Sort_Order !== b.metric.Sort_Order) {
          return a.metric.Sort_Order - b.metric.Sort_Order;
        }
        if (a.url < b.url) return 1;
        if (a.url > b.url) return -1;
        return 0;
      }

      alerts = alerts
        .map((alert) => {
          const metric = metricsDict[alert.metric];
          return {
            ...alert,
            metric: metric,
            key: `${metric.Module}${metric.Name}${alert.url ?? ''}`,
          };
        })
        .filter((alert) =>
          isInformationMetric(alert.metric.Module, alert.metric.Name)
        )
        .sort(sortAlerts);

      return alerts;
    },
    isProducerScheduleEnabled() {
      const metricsDict = this.$store.state.metrics.metricsDict;
      const alerts = this.node?.alerts ?? [];

      return alerts.some((alert) => {
        const metric = metricsDict[alert.metric];
        return (
          metric.Module === 'Producer' && metric.Name === 'ProducerSchedule'
        );
      });
    },
    endpointAlerts() {
      const metricsDict = this.$store.state.metrics.metricsDict;
      const alerts = this.node?.alerts ?? [];

      const endpointAlerts = alerts
        .map((alert) => {
          const metric = metricsDict[alert.metric];
          return {
            ...alert,
            metric,
            key: `${metric.Module}${metric.Name}${alert.url ?? ''}`,
          };
        })
        .filter((alert) =>
          isEndpointMetric(alert.metric.Module, alert.metric.Name)
        );

      return endpointAlerts;
    },
    isRegisteredFinalizerKeysEnabled() {
      const metricsDict = this.$store.state.metrics.metricsDict;
      const alerts = this.node?.alerts ?? [];

      return alerts.some((alert) => {
        const metric = metricsDict[alert.metric];
        return (
          metric.Module === 'Producer' &&
          metric.Name === 'RegisteredFinalizerSigningKeys'
        );
      });
    },
  },
  methods: {
    openNodeEditOverlay() {
      this.$emit('editNode', { chainId: this.chainId, nodeId: this.nodeId });
    },
    getChainId() {
      return this.$route.params.chain;
    },
    getChain() {
      return this.$store.state.chain.chains.filter(
        (chain) => chain.id === this.getChainId()
      )[0];
    },
    getNodeId() {
      return this.$route.params.node;
    },
    getNode() {
      return this.getChain().nodes.filter(
        (node) => node.id === this.getNodeId()
      )[0];
    },
    openMetricsAndAlertsOverlay() {
      this.$emit('editMetricsAndAlerts', {
        chainId: this.chainId,
        nodeId: this.nodeId,
      });
    },
    editAlert(e) {
      this.$emit('editAlert', e);
    },
    toChain() {
      let chainUrl = `/chain/${this.chainId.toString()}`;
      this.$router.push(chainUrl).catch(() => {});
    },
  },
};
</script>

<style></style>
